import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import quinn1 from './assets/images/quinn/quinn1.jpg';
import quinn2 from './assets/images/quinn/quinn2.jpg';
import quinn3 from './assets/images/quinn/quinn3.jpg';
import quinn4 from './assets/images/quinn/quinn4.jpg';
import quinn5 from './assets/images/quinn/quinn5.jpg';
import quinn6 from './assets/images/quinn/quinn6.jpg';
import quinn7 from './assets/images/quinn/quinn7.jpg';
import quinn8 from './assets/images/quinn/quinn8.jpg';
import quinn9 from './assets/images/quinn/quinn9.jpg';
import quinn10 from './assets/images/quinn/quinn10.jpg';
import quinn11 from './assets/images/quinn/quinn11.jpg';
import quinn12 from './assets/images/quinn/quinn12.jpg';
import quinn13 from './assets/images/quinn/quinn13.jpg';
import quinn14 from './assets/images/quinn/quinn14.jpg';
import quinn15 from './assets/images/quinn/quinn15.jpg';
import quinn16 from './assets/images/quinn/quinn16.jpg';
import quinn17 from './assets/images/quinn/quinn17.jpg';
import quinn18 from './assets/images/quinn/quinn18.jpg';


const photos = [
    { src: quinn1, ...WidePhoto },
    { src: quinn2, ...WidePhoto },
    { src: quinn3, ...TallPhoto },
    { src: quinn4, width: 203, height: 152 }, // non-standard size
    { src: quinn5, width: 203, height: 270 }, // non-standard size
    { src: quinn6, ...TallPhoto },
    { src: quinn7, ...TallPhoto },
    { src: quinn8, ...TallPhoto },
    { src: quinn9, ...TallPhoto },
    { src: quinn10, ...TallPhoto },
    { src: quinn11, ...SquarePhoto },
    { src: quinn12, ...SquarePhoto },
    { src: quinn13, ...SquarePhoto },
    { src: quinn14, ...TallPhoto },
    { src: quinn15, ...SquarePhoto },
    { src: quinn16, ...TallPhoto },
    { src: quinn17, ...TallPhoto },
    { src: quinn18, ...TallPhoto },
];

const Quinn = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="female">
                <i className="far fa-venus"></i>
                Quinn
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>LUNANOVA CLAIRCREEK HARLEQUINN</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA</td>
                        <td><span className="title">CKC Registration</span>#KC4157110</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>AM CH / MBIS MBPIS BPISS CAN GCH NORTHSKY DARKHORSE AT LUNANOVA JWD AWD WWD</td>
                        <td><span className="title">Dam</span>GCH CLAIRCREEK SHAKE It OFF</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>CURLY</td>
                        <td><span className="title">Coat Colour</span>BLACK</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>GOOD (ELBOWS NORMAL)	</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Quinn;
